<template>
  <DocumentEditionPage
      :business="business"
      :client-name="clientName"
      :active-category="activeCategory"
      :active-document-number="activeDocumentNumber"
      :is-editable="isEditable"
      :title-input="titleInput"
      :business-elements="inputs.elements"
      :totals="inputs.totals"
      :default-unit-price="defaultUnitPrice"
      :default-tva-percent="defaultTvaPercent"
  />
</template>

<script>
import DocumentEditionPage from "@/components/businessEdition/DocumentEditionPage.vue";
import {BUSINESS_DOCUMENT_TYPE_ENUM} from "@/models/businessDocumentTypeEnum";
import {CREDIT_NOTE_STATUS_ENUM} from "@/models/creditNoteStatusEnum";

export default {
  name: 'CreditNoteDocument',
  components: {DocumentEditionPage},
  props: {
    business: {type: Object, default: undefined},
    clientName: {type: String, default: ''},
    selectedCreditNote: {type: Object, default: undefined},
    inputs: { type: Object, required: true },
    readOnly: {type: Boolean, default: false},
    defaultUnitPrice: {default: undefined},
    defaultTvaPercent: {default: undefined},
  },
  computed: {
    activeCategory() {
      return BUSINESS_DOCUMENT_TYPE_ENUM.CREDIT_NOTE.label;
    },
    activeDocumentNumber() {
      return this.selectedCreditNote ? this.selectedCreditNote.number : '';
    },
    titleInput() {
      return {
        label: 'Titre',
        value: this.selectedCreditNote ? this.selectedCreditNote.body.title : '',
        type: 'text',
        readOnly: true
      };
    },
    isEditable() {
      return !this.readOnly && this.selectedCreditNote.status === CREDIT_NOTE_STATUS_ENUM.CREATION.value;
    },
  },
};
</script>